<script>
  import ProgressBar from '@okrad/svelte-progressbar';

  export let value = 10;
  export let max = 100;
  export let height = 4;
  export let radius = 0.4;
  export let bgColor = '#896BD9';

  $: progress = { perc: (value / max) * 100, color: bgColor };
</script>

<ProgressBar series={[progress]} height={height} textSize={0} rx={radius} ry={radius}></ProgressBar>
